import { createStore } from 'owa-satcheljs';

export type MyOutlookTab =
    | 'foryou'
    | 'mirror'
    | 'profile'
    | 'automations'
    | 'welcome'
    | 'scanProgress';

export type MyOutlookEntryState = 'uninitiated' | 'scanning' | 'firstComplete' | 'steady';

export interface MyOutlookViewState {
    isFullPageShowing: boolean;
    initialTab: MyOutlookTab;
    isSectionHidden: boolean;
    // Dev-only override for the folder-pane entry state. Never persisted —
    // resets to null on refresh. See setEmulatedFolderEntryStateMutator.
    emulatedEntryState: MyOutlookEntryState | null;
    // Whether the schedule timeline is visible on the full page.
    isScheduleVisible: boolean;
}

const getMyOutlookViewState: () => MyOutlookViewState = createStore<MyOutlookViewState>(
    'MyOutlookViewState',
    {
        isFullPageShowing: false,
        initialTab: 'foryou' as MyOutlookTab,
        isSectionHidden: false,
        emulatedEntryState: null,
        isScheduleVisible: true,
    }
);

export default getMyOutlookViewState;
